import styled from "styled-components";

import { colors, space } from "shared/styles/constants";

export const MapContainer = styled.div`
  height: 400px;
`;

interface StyledAddressButtonProps {
  isActive?: boolean;
}

export const StyledAddressButton = styled.div<StyledAddressButtonProps>`
  svg {
    margin-right: ${space.xs};

    color: ${({ isActive }) => (isActive ? colors.red : "inherit")} !important;
  }
`;
